/* eslint-disable max-len */
export default {
  common: {
    PartI: "Part I – Personal particulars",
    PartIcontent: "Personal particulars",
    PartII: "Part II – Specification of cash/bearer negotiable instruments and declaration on property",
    PartIIcontent: "Specification of cash/bearer negotiable instruments and declaration on property",
    PartIII: "Part III – Identification of the owner of cash / bearer negotiable instruments not owned by the declarant",
    // PartIIIcontent: "Identification of the owner of cash / bearer negotiable instruments not owned by the declarant",
    PartIIIcontent: "",
    PartIV: "Part IV – Statement",
    EntryFrom: "Entry from",
    or: "or",
    ExitTo: "Exit to",
    Name: "Name",
    Gender: "Gender",
    Nationality: "Nationality",
    PlaceofBirth: "Place of Birth",
    DateofBrith: "Date of Birth",
    TravelDocumentType: "Travel Document Type",
    TravelDocumentNumber: "Travel Document Number",
    PlaceofIssue: "Place of Issue",
    Permanentaddressandtelephonecontactnumber: "Permanent address and telephone contact number",
    Currency: "Currency",
    Travellerscheque: "Traveller's cheque",
    Cheque: "Cheque",
    Billofexchange: "Bill of exchange",
    MoneyOrder: "Money Order",
    PromissoryNote: "Promissory Note",
    Others: "Others",
    Currencyname: "Currency name",
    Amounttonearestwholenumber: "Amount (to nearest whole number)",
    Doesthedeclarantownthisitem: "Does the declarant own this item",
    Yes: "Yes",
    No: "No",
    theownershouldbeidentifiedontheappropriatefieldofPartIII: "The owner must be indicated under this item",
    LegalPersonCorporatename: "Legal Person (Corporate name)",
    IndividualName: "Individual (Name)",
    M: "M",
    F: "F",
    details: "Fill in at most 1 item A maximum of 30 items may be completed",
    required: "Required Content",
    del: "delete",
    add: "add",
    placeholder: "please enter",
    saveCode: " SaveCode",
    failureCode: "QR code has expired",
    edit: "Re-declare",
    Declares: "Re-declare",
    amount: "Please fill in the amount",
    efficacy: "lost efficacy ",
    confirmDelete: "Confirm cancel",
    tishi: "Please complete the profile",
    Pleaseselectenteringorleavings: "Please select entry or exit",
    confirm: "Confirm",
    cancel: "Cancel",
    warn: "Warn",
    item1: "Item 1",
    item2: "Item 2",
    item3: "Item 3",
    item4: "Item 4",
    item5: "Item 5",
    item6: "Item 6",
    item7: "Item 7",
    item8: "Item 8",
    item9: "Item 9",
    item10: "Item 10",
    item11: "Item 11",
    item12: "Item 12",
    item13: "Item 13",
    item14: "Item 14",
    item15: "Item 15",
    item16: "Item 16",
    item17: "Item 17",
    item18: "Item 18",
    item19: "Item 19",
    item20: "Item 20",
    item21: "Item 21",
    item22: "Item 22",
    item23: "Item 23",
    item24: "Item 24",
    item25: "Item 25",
    item26: "Item 26",
    item27: "Item 27",
    item28: "Item 28",
    item29: "Item 29",
    item30: "Item 30",
    Address: "Statutory seat address (Legal Person) / Individual Permanent Address",
    // 剩下為電腦翻譯
    Thesavewassuccessful: "The save was successful.",
    Pleasemakesuretoreadthedeclaration: "Please make sure to read the declaration.",
    Youcansaveuptotenrecords: "You can save up to ten records",
    Pleasechoosetodeletetheitem: "Please choose to delete the item",
    Whethertoconfirmthedeletion: "Whether to confirm the deletion",
    yyyyMMdd: "yyyy year MM month dd day",
    YearMonthDay: "(Year/Month/Day)",
    Pleaseselect: "Please select (supports direct input keyword retrieval)",
    Pleaseenteryourcontactnumber: "Please enter your contact number",
    Cannotseeclearly: "Can not see clearly? Change it",
    Keepthefilinginformation: "Keep the filing information to this machine for the next re-declaration",
    Ideclare: "I declare that I have read the Notice of Declaration and that the information filled in is true and complete",
    verificationcode: "Please press the icon to enter the verification code",
    pleasekeepthisQRcode: "I need to hold this QR code to customs, to show the customs officer this code for testing and verification, please keep this QR code, so as not to bring inconvenience for their own travel",
    QRcodepicturesarerequired: "QR code pictures are required for customs clearance, please confirm to save locally or take photos to save to your phone. Confirm that the close point still exits, return to save please click on the picture",
    Savethepicture: "Save the picture",
    Stillexit: "Still exit",
    Statement: "Statement",
    Pleaseentertheareacode: "Please enter the area code",
    Pleaseenterthefirstitem: "Please enter the first item",
    Pleaseamount1: "Please enter the amount of item I of Part Two",
    Pleaseamount2: "Please enter the amount of item II of Part Two",
    Pleaseamount3: "Please enter the amount of item III of Part Two",
    Pleasecurrency1: "Please enter the currency name of item I of Part Two",
    Pleasecurrency2: "Please enter the currency name of item II of Part Two",
    Pleasecurrency3: "Please enter the currency name of item III of Part Two",
    Pleasewhether1: "Please enter whether item I of Part Two belongs to the declarer",
    Pleasewhether2: "Please enter whether item II of Part Two belongs to the declarer",
    Pleasewhether3: "Please enter whether item III of Part Two belongs to the declarer",
    Pleasecurrencytype1: "Please Enter the second part, item I currency type",
    Pleasecurrencytype2: "Please Enter the second part, item II currency type",
    Pleasecurrencytype3: "Please Enter the second part, item III currency type",
    PleasePartIII1: "Please Enter Part III Item 1",
    PleasePartIII2: "Please Enter Part III Item 2",
    PleasePartIII3: "Please Enter Part III Item 3",
    PleasePartpersonIII1: "Please enter the name of the legal person/natural person of item 1 of Part III",
    PleasePartpersonIII2: "Please enter the name of the legal person/natural person of item 2 of Part III",
    PleasePartpersonIII3: "Please enter the name of the legal person/natural person of item 3 of Part III",
    PleasePartaddressIII1: "Please enter the permanent residence address of item 1 of Part III",
    PleasePartaddressIII2: "Please enter the permanent residence address of item 2 of Part III",
    PleasePartaddressIII3: "Please enter the permanent residence address of item 3 of Part III",
    Pleaseentertheverificationcode: "Please enter the verification code",
    Personaldata: "Personal data is not perfect or incorrect",
    Whethertoconfirmtheremoval: "Whether to confirm the removal？",
    Thedeletionwassuccessful: "The deletion was successful",
    Is: "Is",
    Save: "Save",
    Cancel: "Cancel",
    Areyousure: "Are you sure",
    Code: "Code",
    aboutus: "about us",
    Contactus: "Contact us",
    Useandprivacypolicy: "Use and privacy policy",
    Addthenextitem: "Add",
    Pleaseenteryourplaceofentry: "Please enter your place of entry",
    Pleaseenteryourexitdestination: "Please enter your exit destination",
    Pleaseenteryourname: "Please enter your name",
    Pleaseenteryournationality: "Please enter your nationality",
    Pleaseenteryourplaceofbirth: "Please enter your place of birth",
    Pleaseselectyourdateofbirth: "Please select your date of birth",
    Pleaseselectyourdocumentcategory: "Please select your document category",
    PleaseenteryourIDnumber: "Please enter your ID number",
    Pleaseenteryourplaceofissue: "Please enter your place of issue",
    Pleaseenteryourpermanentresidenceaddress: "Please enter your permanent residence address",
    Pleaseenteryourareacode: "Please enter your area code",
    Pleaseselectthecurrencytype: "Please select the currency type",
    Pleaseenter: "Please enter",
    Pleaseselectyourcurrencyname: "Please select your currency name",
    Pleaseentertheamount: "Please enter the amount (closest to the integer)",
    Pleaseenterthepermanentresidenceaddressofthelegalentitynaturalperson: "Please enter the permanent residence address of the legal entity/natural person",
    Pleasepresstheicontoentertheverificationcode: "Please press the icon to enter the verification code",
    Delete: "Delete",
    Pleaseselectenteringorleaving: "Please select whether you are entering or leaving the country",
    Immigration: "Enter From",
    Exit: "Exit to",
    Permanentresidenceaddress: "Permanent residence address",
    Contactnumber: "Contact number",
    Stepup: "Step up",
    Nextstep: "Next step",
    Submit: "Submit",
    Whatyouneedtoknowtodeclare: "What you need to know to declare",
    Thesubmissionwassuccessful: "The submission was successful",
    Pleaseselectthefiler: "Or choose to declare records",
    Declare: "Declare",
    Tips: "Tips",
    Carryingcashandnameless: "Cross-Border Transportation of Cash and Bearer Negotiable Instruments",
    OK: "OK",
    Close: "Close",
    CustomsoftheMacaoSpecialAdministrativeRegion: "Customs of the Macao Special Administrative Region",
    AddressMacau: "Edifício de Comando dos Serviços de Alfândega da RAEM, sito na Avenida do Cais de Pac On Travessa Três do Cais de Pac On, Taipa",
    Email: "E-mail",
    Phone: "Phone",
    Fax: "Fax",
    Carrycashandnamelessnegotiableinstruments: "Carry cash and nameless negotiable instruments",
    Declarationofentryandexit: "Declaration of entry and exit",
    Declarationofentryandexitwithcashandnamelessnegotiableinstruments: "Declaration of entry and exit with cash and nameless negotiable instruments",
    Reset: "Reset",
    Filer: "Filer",
    synchronizationText: "Same as first item",
    Themainresponsibilities: "The main responsibilities",
    cancelSynchronizationText: "Cancel same as first item",
    submitL: " Submitting please wait",
    2020: "2020 Macau Customs Copyright",
    rujin: "Please fill in the origin or destination",
    names: "Please fill in your name",
    Genders: "Please select gender",
    Nationalitys: "Please select nationality",
    birthplaces: "Please fill in the place of birth",
    birthTimes: "Please select the date of birth",
    documentTypes: "Please select the certificate category",
    documentNums: "Please fill in the ID number",
    issues: "Please fill in the place of issue",
    addresss: "Please fill in your permanent residence address",
    phones: "Please fill in the phone number",
    tis: "Please select the record information"
  }
};